import { createFileRoute, notFound } from '@tanstack/react-router'
import { EntityCreatePage } from '@/components/entity-page-views'
import {
	getEntityCreateClosePath,
	getEntityCreateCreatedPath,
	getEntityPageBreadcrumb,
	getEntityPageOverride,
} from '@/entity-config-runtime'

export const Route = createFileRoute('/_authenticated/$entity/create')({
	beforeLoad: ({ params, context }) => {
		const entity = String(params.entity ?? '')
		if (!entity || entity === 'user' || !context.ability.can('write', entity)) {
			throw notFound({})
		}
	},
	staticData: {
		breadcrumb: ({ params, search }) =>
			getEntityPageBreadcrumb(String(params.entity ?? ''), 'create', {
				params,
				search,
			}),
	},
	component: EntityCreateRoute,
})

function EntityCreateRoute() {
	const { entity } = Route.useParams()
	const navigate = Route.useNavigate()

	const handleClose = () => {
		navigate({ to: getEntityCreateClosePath(entity), search: true })
	}

	const handleCreated = (id?: string | number) => {
		const createdPath = getEntityCreateCreatedPath(entity, id)
		if (createdPath) {
			navigate({ to: createdPath })
			return
		}

		handleClose()
	}

	const basePageProps = {
		entity,
		onClose: handleClose,
		onCreated: handleCreated,
	}
	const OverrideComponent = getEntityPageOverride(
		entity,
		'create',
	)?.createComponent

	if (OverrideComponent) {
		return <OverrideComponent {...basePageProps} />
	}

	return <EntityCreatePage {...basePageProps} />
}
